<template>
  <onboarding-flow
    :step-id="stepId"
    :data="data"
    @update-data="onUpdateData"
    @change-step="onChangeStep"
  />
</template>
<script>
import Vue from 'vue';

import OnboardingFlow from './OnboardingFlow.vue';

export default Vue.extend({
  components: {
    OnboardingFlow,
  },

  layout: 'standalone',

  middleware: ['auth', 'verified', 'employee'],

  data: () => ({
    data: null,
  }),

  computed: {
    stepId() {
      return this.$route.query.step;
    },
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      const employee = this.$auth.me;
      const organization = this.$auth.me.organization;

      this.data = {
        employee,
        organization,
      };
    },

    onUpdateData(data) {
      if (data.employee) {
        this.$auth.commit('PATCH_ME', { ...data.employee });
        this.data.employee = {
          ...this.data.employee,
          ...data.employee,
        };
      }

      if (data.organization) {
        this.$auth.commit('PATCH_ME', {
          organization: { ...data.organization },
        });
        this.data.organization = {
          ...this.data.organization,
          ...data.organization,
        };
      }
    },

    onChangeStep(step) {
      this.$router.push({
        name: this.$RouteEnum.EMPLOYEE_ONBOARDING,
        query: {
          step: step.slug,
        },
      });
    },
  },
});
</script>
